import CourseSyllabus from "../common/CourseSyllabus/CourseSyllabus";

const aiSyllabus = {
    basic: [
        {
            id: "ai-basic-1",
            title: "Introduction to Data Science & AI",
            content: [
                "What is Data Science?",
                "What is Artificial Intelligence?",
                "Relationship between Data Science, Machine Learning, and AI",
                "Applications of AI in real-world industries",
                "AI use cases in business and technology",
                "Data Science and AI career opportunities",
            ],
        },
        {
            id: "ai-basic-2",
            title: "Foundation Concepts",
            content: [
                "Understanding data, information, and knowledge",
                "Introduction to Artificial Intelligence concepts",
                "Machine Learning fundamentals",
                "Supervised, unsupervised, and reinforcement learning",
                "Basic AI terminology",
                "AI workflow and problem-solving approach",
            ],
        },
        {
            id: "ai-basic-3",
            title: "Data & Analytics Overview",
            content: [
                "What is data analytics?",
                "Types of data analytics",
                "Descriptive analytics",
                "Diagnostic analytics",
                "Predictive analytics",
                "Prescriptive analytics",
                "Role of analytics in AI and Data Science",
            ],
        },
        {
            id: "ai-basic-4",
            title: "Understanding Data",
            content: [
                "Types of data",
                "Structured and unstructured data",
                "Qualitative and quantitative data",
                "Categorical and numerical data",
                "Data collection methods",
                "Data quality and consistency",
                "Data preprocessing basics",
            ],
        },
        {
            id: "ai-basic-5",
            title: "Data Storage & Architecture",
            content: [
                "Introduction to data storage",
                "Files and databases",
                "Relational databases",
                "NoSQL databases",
                "Data warehouses",
                "Data lakes",
                "Introduction to cloud data storage",
                "Basic data architecture concepts",
            ],
        },
        {
            id: "ai-basic-6",
            title: "Big Data",
            content: [
                "What is Big Data?",
                "Characteristics of Big Data",
                "The 5 Vs of Big Data",
                "Big Data processing challenges",
                "Batch processing and stream processing",
                "Introduction to Hadoop",
                "Introduction to Spark",
                "Big Data applications",
            ],
        },
    ],

    intermediate: [
        {
            id: "ai-intermediate-1",
            title: "Deep Dive into Data Science",
            content: [
                "Data Science lifecycle",
                "Problem definition and business understanding",
                "Data collection",
                "Data exploration",
                "Data preparation",
                "Data analysis",
                "Model building",
                "Model evaluation",
                "Deployment and monitoring",
            ],
        },
        {
            id: "ai-intermediate-2",
            title: "Data Acquisition & Preparation",
            content: [
                "Data acquisition techniques",
                "Working with datasets",
                "Importing CSV and Excel data",
                "Handling missing values",
                "Removing duplicate data",
                "Data cleaning",
                "Data transformation",
                "Feature preparation",
                "Data normalization and standardization",
            ],
        },
        {
            id: "ai-intermediate-3",
            title: "Python Programming",
            content: [
                "Python fundamentals for Data Science",
                "Variables and data types",
                "Operators",
                "Conditional statements",
                "Loops",
                "Functions",
                "Modules and packages",
                "Working with Python libraries",
            ],
        },
        {
            id: "ai-intermediate-4",
            title: "Python Data Structures",
            content: [
                "Lists",
                "Tuples",
                "Sets",
                "Dictionaries",
                "Indexing and slicing",
                "List and dictionary operations",
                "Nested data structures",
                "Iterating through collections",
                "Practical Data Science examples",
            ],
        },
        {
            id: "ai-intermediate-5",
            title: "NumPy & Pandas",
            content: [
                "Introduction to NumPy",
                "NumPy arrays",
                "Array operations",
                "Indexing and slicing",
                "Mathematical operations",
                "Introduction to Pandas",
                "Series and DataFrames",
                "Reading CSV and Excel files",
                "Filtering and sorting data",
                "Data cleaning with Pandas",
                "Data transformation",
            ],
        },
        {
            id: "ai-intermediate-6",
            title: "Functions, OOP & Classes",
            content: [
                "Defining and calling functions",
                "Function parameters and return values",
                "Lambda functions",
                "Object-Oriented Programming",
                "Classes and objects",
                "Constructors",
                "Instance and class variables",
                "Methods",
                "Inheritance",
                "Polymorphism",
                "Encapsulation",
            ],
        },
        {
            id: "ai-intermediate-7",
            title: "Statistics for Data Science",
            content: [
                "Introduction to statistics",
                "Population and sample",
                "Mean, median, and mode",
                "Range and variance",
                "Standard deviation",
                "Probability fundamentals",
                "Normal distribution",
                "Correlation",
                "Covariance",
                "Statistical analysis for Data Science",
            ],
        },
    ],

    advanced: [
        {
            id: "ai-advanced-1",
            title: "Machine Learning with Python",
            content: [
                "Introduction to Machine Learning",
                "Machine Learning workflow",
                "Supervised learning",
                "Unsupervised learning",
                "Regression algorithms",
                "Classification algorithms",
                "Clustering algorithms",
                "Training and testing datasets",
                "Feature selection",
                "Scikit-learn fundamentals",
            ],
        },
        {
            id: "ai-advanced-2",
            title: "Model Tuning & Evaluation",
            content: [
                "Model evaluation fundamentals",
                "Training, validation, and test datasets",
                "Cross-validation",
                "Accuracy, precision, recall, and F1-score",
                "Confusion matrix",
                "Regression evaluation metrics",
                "Overfitting and underfitting",
                "Hyperparameter tuning",
                "Grid Search",
                "Random Search",
            ],
        },
        {
            id: "ai-advanced-3",
            title: "Text Mining & NLP",
            content: [
                "Introduction to Natural Language Processing",
                "Understanding text data",
                "Text preprocessing",
                "Tokenization",
                "Stop words",
                "Stemming and lemmatization",
                "Bag of Words",
                "TF-IDF",
                "Text classification",
                "Sentiment analysis",
                "Introduction to language models",
            ],
        },
        {
            id: "ai-advanced-4",
            title: "PySpark & MLlib",
            content: [
                "Introduction to Apache Spark",
                "PySpark architecture",
                "Spark DataFrames",
                "Working with large datasets",
                "Data transformations",
                "Data aggregation",
                "Spark SQL",
                "Introduction to MLlib",
                "Building Machine Learning pipelines",
                "Distributed Machine Learning",
            ],
        },
        {
            id: "ai-advanced-5",
            title: "Deep Learning & AI",
            content: [
                "Introduction to Deep Learning",
                "Neural network fundamentals",
                "Artificial neurons",
                "Layers and network architecture",
                "Activation functions",
                "Forward propagation",
                "Backpropagation",
                "Loss functions",
                "Optimizers",
                "Deep Learning applications",
            ],
        },
        {
            id: "ai-advanced-6",
            title: "CNNs, RNNs, and LSTMs",
            content: [
                "Introduction to Convolutional Neural Networks",
                "CNN architecture",
                "Convolution and pooling",
                "Image classification",
                "Introduction to Recurrent Neural Networks",
                "Sequence data",
                "RNN architecture",
                "Long Short-Term Memory networks",
                "LSTM architecture",
                "Applications of CNNs, RNNs, and LSTMs",
            ],
        },
        {
            id: "ai-advanced-7",
            title: "RBM & Autoencoders",
            content: [
                "Introduction to Restricted Boltzmann Machines",
                "RBM architecture",
                "RBM training concepts",
                "Applications of RBMs",
                "Introduction to Autoencoders",
                "Encoder and decoder architecture",
                "Data reconstruction",
                "Dimensionality reduction",
                "Denoising autoencoders",
                "Applications of Autoencoders",
            ],
        },
        {
            id: "ai-advanced-8",
            title: "TensorFlow & Keras",
            content: [
                "Introduction to TensorFlow",
                "TensorFlow architecture",
                "Introduction to Keras",
                "Creating neural networks",
                "Building deep learning models",
                "Model compilation",
                "Training and validation",
                "Model evaluation",
                "Saving and loading models",
                "Building practical AI applications",
            ],
        },
    ],
};

function AISyllabus() {
    return (
        <CourseSyllabus
            courseName="Artificial Intelligence"
            syllabus={aiSyllabus}
        />
    );
}

export default AISyllabus;